/**
* Created by lobin on 2020/6/17.
*/
<template>
  <span>
    <a-badge status="error" v-if="status == 1" />
    <a-badge status="default" v-if="status == 9" />
    <a-badge status="processing" v-if="status == 0" />
    <span v-if="isDataChannel !== undefined">
      <a-tag color="#87d068" v-if="isDataChannel">主</a-tag>
      <a-tag color="#108ee9" v-else>备</a-tag>
    </span>
  </span>
</template>

<script type="text/babel">
export default {
  props: ['status', 'isDataChannel'],
  data() {
    return {};
  },
};
</script>

<style lang="less" rel="stylesheet/less">
</style>
